var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLineUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.25 3.75C2.66421 3.75 3 4.08579 3 4.5V18.75H21.75C22.1642 18.75 22.5 19.0858 22.5 19.5C22.5 19.9142 22.1642 20.25 21.75 20.25H2.25C1.83579 20.25 1.5 19.9142 1.5 19.5V4.5C1.5 4.08579 1.83579 3.75 2.25 3.75Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.2803 8.46967C19.5732 8.76256 19.5732 9.23744 19.2803 9.53033L14.0303 14.7803C13.7374 15.0732 13.2626 15.0732 12.9697 14.7803L10.5 12.3107L7.28033 15.5303C6.98744 15.8232 6.51256 15.8232 6.21967 15.5303L3.96967 13.2803C3.67678 12.9874 3.67678 12.5126 3.96967 12.2197C4.26256 11.9268 4.73744 11.9268 5.03033 12.2197L6.75 13.9393L9.96967 10.7197C10.2626 10.4268 10.7374 10.4268 11.0303 10.7197L13.5 13.1893L18.2197 8.46967C18.5126 8.17678 18.9874 8.17678 19.2803 8.46967Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5 6.75C16.5 6.33579 16.8358 6 17.25 6H21C21.4142 6 21.75 6.33579 21.75 6.75V10.5C21.75 10.9142 21.4142 11.25 21 11.25C20.5858 11.25 20.25 10.9142 20.25 10.5V7.5H17.25C16.8358 7.5 16.5 7.16421 16.5 6.75Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLineUp);
export default __webpack_public_path__ + "static/media/line-up.b686f9ea41255722c5e0de647281f924.svg";
export { ForwardRef as ReactComponent };